<ng-container *ngTemplateOutlet="data.ordered ? ordered : unordered;">
</ng-container>

<!-- Ordered list -->
<ng-template #ordered>
  <ol [type]="data.mark" [start]="data.startList" [style]="{'padding-left':'calc(2rem + '+15*data.indent+'px)'}">
    <li *ngFor="let item of data.list">{{item}}</li>
  </ol>
</ng-template>

<!-- Unordered list -->
<ng-template #unordered>
  <ul [type]="data.mark" [style]="{'padding-left':'calc(2rem + '+15*data.indent+'px)'}">
    <li *ngFor="let item of data.list">{{item}}</li>
  </ul>
</ng-template>
